import type { Command, CommandInput } from "@vortex-os/slash-commands";
import { collectAgenda, type AgendaReport, type CollectAgendaOptions } from "../agenda.js";

/**
 * `/agenda` — "What should I do today?" Read-only synthesis over existing
 * worklog + decision-log records (open `- [ ]` tasks, active decisions, last
 * activity). Returns structured {@link AgendaReport} data; the host renders it
 * (or calls `renderAgenda`). No writes, no new store — answers from what's
 * already recorded, and adapts to any data state (new / quiet / busy).
 */
export const agendaCommand: Command<AgendaReport> = {
  name: "agenda",
  description:
    "What should I do today? Synthesize open tasks (- [ ] in recent worklogs), active decisions, and last activity from existing records.",
  handler: async (input: CommandInput): Promise<AgendaReport> => {
    const opts: CollectAgendaOptions = {};
    return collectAgenda(input.context, opts);
  },
};
